import { render, staticRenderFns } from "./EditAlt.vue?vue&type=template&id=7ed16cf3&scoped=true"
import script from "./EditAlt.vue?vue&type=script&lang=js"
export * from "./EditAlt.vue?vue&type=script&lang=js"
import style0 from "./EditAlt.vue?vue&type=style&index=0&id=7ed16cf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed16cf3",
  null
  
)

export default component.exports